export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  excerpt: string;
}

export const news: NewsItem[] = [
  {
    id: 'news-1',
    title: '《蜜桃成熟时33D》修复版画质细节赏析',
    date: '2026-09-28',
    category: '影片资讯',
    excerpt: '本期我们聊聊修复版在光线与色彩上的细节提升，看看那些被时间藏起来的画面层次。',
  },
  {
    id: 'news-2',
    title: '从《蜜桃成熟时》到33D：系列成长线梳理',
    date: '2026-09-20',
    category: '系列专题',
    excerpt: '梳理系列作品在人物与主题上的延续与变化，帮助你更快理解整个故事脉络。',
  },
  {
    id: 'news-3',
    title: '演员访谈：林晓莓谈如何理解「成熟」',
    date: '2026-09-12',
    category: '演员访谈',
    excerpt: '林晓莓分享了她对角色的理解，以及拍摄期间那些关于成长的真实感受。',
  },
  {
    id: 'news-4',
    title: '同类型都市爱情影片观影指南',
    date: '2026-09-05',
    category: '观影指南',
    excerpt: '如果你喜欢《蜜桃成熟时33D》的氛围，这几部同类型作品或许也值得一看。',
  },
];

export const hotKeywords = [
  '蜜桃成熟时33D',
  '蜜桃成熟时33D剧情',
  '都市爱情',
  '青春治愈',
  '文艺片推荐',
  '演员资料',
  '系列作品',
  '观影指南',
];